import { render, staticRenderFns } from "./grid-label-value.vue?vue&type=template&id=ce2ffd74"
import script from "./grid-label-value.ts?vue&type=script&lang=js&external"
export * from "./grid-label-value.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports